import type { Form } from '../../../../common/types/form';
import type { FhbfMeasure } from '../../../../common/types/client';

const measureForm: Form<FhbfMeasure> = {
  key: 'measure',
  title: 'Beratung',
  fields: [
    {
      key: 'type',
      label: 'Art der Beratung',
      fieldTypes: 'select',
      options: [
        {
          value: 'telephoneConsultation',
          label: 'Telefonische Beratung',
        },
        {
          value: 'personalConsultation',
          label: 'Persönliche Beratung',
        },
        {
          value: 'outreachConsultation',
          label: 'Aufsuchende Beratung',
        },
        {
          value: 'accompaniment',
          label: 'Begleitung',
        },
        {
          value: 'onlineConsultation',
          label: 'Onlineberatung',
        },
        {
          value: 'followUp',
          label: 'Follow-Up Beratung',
        },
      ],
    },
    {
      key: 'topic',
      label: 'Thematik',
      fieldTypes: 'checkboxSelect',
      options: [
        { label: 'Häusliche Gewalt', value: 'domesticViolence' },
        { label: 'Stalking', value: 'stalking' },
        { label: 'Mobbing', value: 'bullying' },
        { label: 'FGM', value: 'fgm' },
        { label: 'Psychosoziale Beratung', value: 'psychosocialCounseling' },
        { label: 'Traumafachberatung', value: 'traumaCounseling' },
        { label: 'Sonstige', value: 'other' },
      ],
    },
    {
      key: 'otherTopic',
      label: 'Sonstige Thematik',
      fieldTypes: 'text',
      isVisible: (measure) => measure.topic != null && measure.topic.includes('other'),
    },
    {
      key: 'date',
      label: 'Datum',
      xsWidth: 6,
      fieldTypes: 'date',
    },
    {
      key: 'duration',
      label: 'Dauer in Minuten',
      xsWidth: 6,
      fieldTypes: 'number',
    },
    {
      key: 'translator',
      label: 'Dolmetscher*in',
      fieldTypes: 'checkbox',
      xsWidth: 3,
    },
    {
      key: 'riskQuestionnaire',
      label: 'Risikofragebogen',
      fieldTypes: 'checkbox',
      xsWidth: 3,
    },
    {
      key: 'appointmentDidNotTakePlace',
      label: 'Termin hat trotz Vereinbarung nicht stattgefunden',
      fieldTypes: 'checkbox',
      xsWidth: 6,
    },
    {
      key: 'consultingContent',
      label: 'Beratungsinhalte',
      fieldTypes: 'richTextArea',
      rows: 13,
    },
    {
      key: 'todos',
      label: 'Zu erledigen',
      fieldTypes: 'textArea',
    },
  ],
};

export default measureForm;
